const _ = require('underscore');
const model = require('model/model');
const analyticsUtilities = require('utilities/analyticsUtilities');
const fireEvent = analyticsUtilities.fireEvent;
const PREVIEW_ARTICLE = analyticsUtilities.events.PREVIEW_ARTICLE;
const PREVIEW_VIDEO = analyticsUtilities.events.PREVIEW_VIDEO;
const PREVIEW_BOK = analyticsUtilities.events.PREVIEW_BOK;
const PREVIEW_STEPREAD = analyticsUtilities.events.PREVIEW_STEPREAD;
const PREVIEW_QUESTIONS = analyticsUtilities.events.PREVIEW_QUESTIONS;
const PREVIEW_EBOOK = analyticsUtilities.events.PREVIEW_EBOOK;
const PREVIEW_WD = analyticsUtilities.events.PREVIEW_WD;
const PREVIEW_MM = analyticsUtilities.events.PREVIEW_MM;
const PREVIEW_VOCAB = analyticsUtilities.events.PREVIEW_VOCAB;

const modelKeysToWatch = ['articleTab', 'questionsetsSection', 'stepreadsSection', 'contentSection', 'activeProduct', 'decodablesArticle'];

// Keys that don't contain the tab name
let keyToTabRelationshipMap = {
	answerKey: 'questionsets'
};

const onPageView = (extraData, key) => {
	let activeProduct = model.get('activeProduct');
	let articleTab = model.get('articleTab');
	let eventName = null;

	// Currently limited to articleTab / product preview
	if (activeProduct && articleTab) {
		let activeProductId = activeProduct.id || activeProduct.uuid;
		let printing = model.get('printing');
		let questionsetsSection = model.get('questionsetsSection');
		let stepreadsSection = model.get('stepreadsSection');
		let contentSection = model.get('contentSection');
		let ebookPage = model.get('ebookPage');
		let answerKey = model.get('answerKey');
		let wboard = model.get('whiteboardView') || undefined;
		let data = {
			articleTab,
			pid: activeProductId,
			wboard
		};
		const hasMultipleArticles = ['AAD', 'P', 'TS'].includes(activeProduct.productType);
		const childProductData =
			hasMultipleArticles && contentSection
				? {
						pid: contentSection,
						parentPid: activeProductId
					}
				: {};

		if (
			printing ||
			(key !== 'activeProduct' && !(keyToTabRelationshipMap[key] === articleTab) && key !== 'articleTab' && key.toLowerCase().indexOf(articleTab) === -1)
		) {
			// event isn't relevant to current tab
			return;
		}

		switch (articleTab) {
			case 'content':
				if (hasMultipleArticles) {
					// If AAD, PT, or TS - ensure we have contentSection / child PID
					if (contentSection) {
						let boost = undefined;
						let challenge = undefined;
						eventName = PREVIEW_ARTICLE;
						if (activeProduct.articles[contentSection] && activeProduct.articles[contentSection].subType === 103) {
							eventName = PREVIEW_VIDEO;
						} else if (activeProduct.productType === 'AAD' && !activeProduct.articles[contentSection] && activeProduct.supplemental_texts) {
							if (activeProduct.supplemental_texts.challenge && activeProduct.supplemental_texts.challenge[contentSection]) {
								challenge = true;
							} else if (activeProduct.supplemental_texts.support && activeProduct.supplemental_texts.support[contentSection]) {
								boost = true;
							}
						}
						data = _.assign(data, childProductData, {
							challenge,
							boost
						});
					}
				} else {
					eventName = PREVIEW_ARTICLE;
				}
				break;
			case 'video':
				eventName = PREVIEW_VIDEO;
				break;
			case 'book-of-knowledge':
				eventName = PREVIEW_BOK;
				break;
			case 'stepreads':
				if (stepreadsSection && activeProduct.articles) {
					let stepread = activeProduct.articles[stepreadsSection];
					data = _.assign(data, {
						stepreadsPid: stepreadsSection,
						stepreadsNumber: stepread.order
					});
					eventName = PREVIEW_STEPREAD;
				}
				break;
			case 'questionsets':
				if (questionsetsSection) {
					data = _.assign(data, {
						qsid: questionsetsSection,
						answerKey: answerKey || false
					});

					if (activeProduct.productType === 'TS') {
						data = Object.assign(data, childProductData);
					}

					eventName = PREVIEW_QUESTIONS;
				}
				break;
			case 'ebook':
				if (typeof ebookPage === 'number') {
					eventName = PREVIEW_EBOOK;
					data = _.assign(data, {
						page: ebookPage
					});
				}
				break;
			case 'word-detective-preview':
				eventName = PREVIEW_WD;
				break;
			case 'meaning-mapper-preview':
				eventName = PREVIEW_MM;
				break;
			case 'vocab-activities':
				eventName = PREVIEW_VOCAB;
				if (activeProduct.productType === 'TS') {
					data = Object.assign(data, childProductData);
				}
				break;
			case 'decodables':
				eventName = PREVIEW_ARTICLE;

				const decodablesArticle = model.get('decodablesArticle');
				const dteGroup = model.get('decodablesSection');

				data = Object.assign(data, {
					pid: decodablesArticle,
					dteGroup,
					parentPid: activeProductId
				});

				break;
		}

		if (eventName && data) {
			if (extraData) {
				_.assign(data, extraData);
			}

			fireEvent(eventName, data);
		}
	}
};

// Keys that should fire PREVIEW_* events
modelKeysToWatch.forEach(key =>
	model.change(key, value => {
		if (typeof value !== 'undefined' && value !== null) {
			onPageView(null, key);
		}
	})
);

// Fire PREVIEW_* events manually with the exported function
module.exports = {
	onPageView
};
